import useAxiosService from './useAxiosService'
import { IClinicInfo, IClinicMajor, IClinicService } from 'interfaces'
import { IResponse } from 'interfaces/services'
import { IUpdateClinicQuery } from 'pages/accountClinicInfo/interfaces'
import {
  IGroupService,
  IImportGroupService
} from 'pages/menuGroupService/interfaces'

export const useClinicServices = () => {
  const { get, post } = useAxiosService()

  const getClinicServices = async (
    query?: any
  ): Promise<IResponse<Array<IClinicService>>> => {
    if (query) return getClinicServiceByMajor(query)
    return getAllClinicService()
  }

  const getAllClinicService = async (): Promise<
    IResponse<Array<IGroupService>>
  > => {
    const response: any = await post('/clinic/services/search', { limit: 0 })
    return {
      ...response,
      data: response.data?.services
    } as IResponse<Array<IGroupService>>
  }

  const getClinicInfo = async () => {
    const response: any = await get('/clinic/info')
    return response as IResponse<IClinicInfo>
  }

  const updateClinic = async (query: IUpdateClinicQuery) => {
    const response: any = await post('/clinic/info', query)
    return response as IResponse<IClinicInfo>
  }

  const getClinicMajors = async () => {
    const response: any = await get('/clinic-major')
    return { ...response, data: response.data?.majors } as IResponse<
      Array<IClinicMajor>
    >
  }

  const getClinicServiceByMajor = async (query: any) => {
    const response: any = await post('/clinic/services/search', query)
    return { ...response, data: response.data?.services } as IResponse<
      Array<IClinicService>
    >
  }

  const getGroupServices = async (query: any) => {
    const response: any = await post('/clinic/services/search', query)
    return response as IResponse<IClinicInfo>
  }

  const importGroupServices = async (query: any) => {
    const response: any = await post('/clinic/services/import', query)
    return response as IResponse<IImportGroupService>
  }

  return {
    getClinicServices,
    getClinicInfo,
    getClinicMajors,
    getClinicServiceByMajor,
    updateClinic,
    getGroupServices,
    getAllClinicService,
    importGroupServices
  }
}
